export enum recurrenceTypes {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  BIWEEKLY = 'bi-weekly',
  MONTHLY = 'monthly',
  BIMONTHLY = 'bi-monthly',
  QUARTERLY = 'quarterly',
  SEMIANNUALLY = 'semi-annually',
  ANNUALLY = 'annually',
}

export const recurrenceOptions: { label: string; value: string }[] = [
  {
    label: 'Daily',
    value: recurrenceTypes.DAILY,
  },
  {
    label: 'Weekly',
    value: recurrenceTypes.WEEKLY,
  },
  {
    label: 'Bi-weekly',
    value: recurrenceTypes.BIWEEKLY,
  },
  {
    label: 'Monthly',
    value: recurrenceTypes.MONTHLY,
  },
  {
    label: 'Bi-monthly',
    value: recurrenceTypes.BIMONTHLY,
  },
  {
    label: 'Quarterly',
    value: recurrenceTypes.QUARTERLY,
  },
  {
    label: 'Semi-annually',
    value: recurrenceTypes.SEMIANNUALLY,
  },
  {
    label: 'Annually',
    value: recurrenceTypes.ANNUALLY,
  },
];

export const RECURRENCE_DAYS_LIMIT: Record<string, number> = {
  'daily': 1,
  'weekly': 7,
  'bi-weekly': 14,
  'monthly': 31,
  'bi-monthly': 60,
  'quarterly': 90,
  'semi-annually': 180,
  'annually': 365,
};
